import dayjs from 'dayjs'
import { booking } from '@/api/booking'
import { invoice } from '@/api/invoice'
import { commonServices } from '@/api/common-services'
import 'devextreme/dist/css/dx.light.css'
import { Workbook } from 'exceljs'
import { exportDataGrid } from 'devextreme/excel_exporter'
import { saveAs } from 'file-saver-es'
import { convertUTC } from '@/@core/utils/utils'
import ExcelJS from "exceljs";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxFilterRow,
  DxHeaderFilter,
  DxGroupPanel,
  DxGrouping,
  DxScrolling,
  DxPaging,
  DxPager,
  DxSummary,
  DxLookup,
  DxTotalItem,
  DxGroupItem,
  DxMasterDetail,
  DxStringLengthRule,
  DxRequiredRule,
  DxRangeRule,
  DxValueFormat,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
} from 'devextreme-vue/data-grid'
import SidebarMergeService from './SidebarMergeService/SidebarMergeService.vue'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Treeselect from '@riophae/vue-treeselect'
const dataGridRef = 'dataGrid'
export default {
  name: 'ListPayment',
  components: {
    SidebarMergeService,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxFilterRow,
    DxHeaderFilter,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxPaging,
    DxPager,
    DxSummary,
    DxLookup,
    DxTotalItem,
    DxGroupItem,
    DxMasterDetail,
    DxStringLengthRule,
    DxRangeRule,
    DxRequiredRule,
    DxValueFormat,
    DxColumnChooser,
    DxColumnFixing,
    DxSelection,
    DxExport,
    Treeselect,
  },
  data() {
    return {
      dataGridRef,
      search: {
        ClientId: [],
        KeyWord: '',
        BDC: [],
        FromDate: this.getUTC('start', 'day'),
        ToDate: this.getUTC('start', 'day'),
        PaymentCode: null,
        InvoiceNo: null,
        Page:1,
        PageSize:50,
        Type:'',
        PaymentMethod:null

      },
      listPayment: [],
      currentPage: 1,
      totalRow: 0,
      perPage: 100,
      allMode: 'allPages',
      checkBoxesMode: 'onClick', // 'always' :
      optionPerPage: [100, 250, 500],
      optionType:[
        {
          id: 'FULL_MONEY',
          label: this.$t('golf_common_search_by_invoice_no_still'),
        },
        {
          id: 'REMAIN_MONEY',
          label: this.$t('golf_common_search_by_invoice_still'),
        },
        
        {
          id: 'ALL',
          label: this.$t('golf_common_search_by_invoice_all'),
        }
      ],
      optionPaymentMethod:[],
      configTable: [
        {
          caption: 'BDC',
          field: 'BDC',
          isShow: true,
          alignment: 'left',
        },
        {
          caption: this.$t('golf_common_full_name'),
          field: 'FullName',
          isShow: true,
          alignment: 'left',
        },
        {
          caption: this.$t('golf_common_number_of_hole'),
          field: 'NumberOfHole',
          isShow: true,
          alignment: 'left',
        },
        {
          caption: 'Tee Time',
          field: 'TeeTime',
          isShow: true,
          alignment: 'left',
          cellTemplate: 'TeeTime',
        },
        {
          caption: 'TA',
          field: 'ClientName',
          isShow: true,
          alignment: 'left',
        },
        {
          caption: this.$t('golf_tax_invoice_payment_code'),
          field: 'PaymentCode',
          isShow: true,
          alignment: 'left',
          cellTemplate: 'PaymentCode',
        },
        {
          caption: this.$t('golf_tax_invoice_booking_code'),
          field: 'Id',
          isShow: true,
          alignment: 'left',
          cellTemplate: 'BookingCode',
        },
        {
          caption: this.$t('golf_payment_payment_method'),
          field: 'PaymentMethod',
          isShow: true,
          alignment: 'left',
        },
        {
          caption: this.$t('golf_tax_invoice_payment_date'),
          field: 'FiscalPaymentDate',
          isShow: true,
          alignment: 'left',
          cellTemplate: 'FiscalPaymentDate',
        },
        {
          caption: this.$t('golf_common_total'),
          field: 'TotalAmount',
          isShow: true,
          cellTemplate: 'TotalAmount',
          alignment: 'right',
        },
        {
          caption: this.$t('golf_common_amount_of_einvoice'),
          field: 'AmountOfEInvoice',
          isShow: true,
          cellTemplate: 'AmountOfEInvoice',
          alignment: 'right',
        },
        {
          caption: this.$t('golf_common_amount_not_of_einvoice'),
          field: 'AmountNotEInvoice',
          isShow: true,
          cellTemplate: 'AmountNotEInvoice',
          alignment: 'right',
        },
        {
          caption: 'Invoice',
          field: 'Invoice',
          isShow: true,
          alignment: 'left',
          cellTemplate: 'Invoice',
        },
        // {
        //   caption: '',
        //   field: 'action',
        //   isShow: true,
        //   cellTemplate: 'action',
        //   alignment: 'center',
        // },
      ],
      isLoading: false,
      selectedRowsData: [],
      paymentDataSelected: [],
      listClient: [],
      listCashiers: [],
      zoneId: null,
      listPaymentType: [],
      paymentTypeOptions: [],
      listPaymentMethodEInvocie: [],
      checkModuleEInvocie: JSON.parse(localStorage.getItem('module')).find(x => x == "EINVOICE"),
      columnWidths :[],
      TotalAmount :0,
      TotalAmountNotOfEInvoice :0,
      TotalAmountOfEInvoice :0,
      listPaymentMethodByRoomId :[],
      isShowPaymentByRoom : true
    }
  },
  computed: {
    dataGrid() {
      return this.$refs[dataGridRef].instance
    },
     totalPages() {
    return Math.ceil(this.totalRow / this.perPage);
  },
  startRecord() {
    return (this.currentPage - 1) * this.perPage + 1;
  },
  endRecord() {
    return Math.min(this.currentPage * this.perPage, this.totalRow);
  }
  },
  created() {
    
    this.getListClient()
    this.getListPaymentMethodEInvoice()
    this.getConfigInfo_RCOM01()
    this.getListCashier_RCS01()
  },
  watch: {
    currentPage:function ( newVal){
      this.getListPayment_RPMI01()
   },
   perPage: function ( newVal){
    this.getListPayment_RPMI01()
   }
 },
 mounted() {
  // Gán mặc định phần tử đầu tiên
  const remainOption = this.optionType.find(item => item.id === 'REMAIN_MONEY');
if (remainOption) {
  this.search.Type = remainOption.id;
  this.getListPayment_RPMI01();
}
  this.$nextTick(() => {
    const summaryScroll = this.$refs.summaryScrollWrapper;

    // Chờ DevExtreme DataGrid khởi tạo xong
    const interval = setInterval(() => {
      const dataGridInstance = this.$refs[dataGridRef].instance
      if (dataGridInstance) {
        const gridScrollable = dataGridInstance.getScrollable();
        const gridScrollEl = gridScrollable?.container();

        if (gridScrollEl && summaryScroll) {
          // Gắn sự kiện scroll để đồng bộ scrollLeft
          gridScrollEl.addEventListener('scroll', () => {
            summaryScroll.scrollLeft = gridScrollEl.scrollLeft;
          });

          clearInterval(interval); // Xong thì clear
        }
      }
    }, 100); // Check mỗi 100ms đến khi có instance
  });
  },
  methods: {
    _dayjs: dayjs,
    syncColumnWidths() {
      const instance = this.$refs[dataGridRef].instance;
      const columns = instance.getVisibleColumns();
      this.columnWidths = columns.map((col) => col.visibleWidth || col.width || 100);
    },
    getColWidth(index) {
      return this.columnWidths[index] ? `${this.columnWidths[index]}px` : 'auto';
    },
    getTotalColWidth(start, span) {
      const total = this.columnWidths.slice(start, start + span).reduce((a, b) => a + b, 0);
      return `${total}px`;
    },
    getSelectedData() {
      this.selectedRowsData = this.dataGrid.getSelectedRowsData()
    },
    async getConfigInfo_RCOM01() {

      await booking.getConfigInfo({ KeyGroup: 'EINVOICE' }).then(async response => {
        if (response.Status === '200') {
          this.isShowPaymentByRoom = (response?.Data || []).some(x => x.KeyCode === 'PAYMENT_INVOICE_IS_SHOW_PAYMENT_BY_ROOM' && x.KeyValue === '1');
        }
    })

      await booking.getConfigInfo({ KeyGroup: 'PAYMENT_CONFIG' }).then(async response => {
        if (response.Status === '200') {
          this.listPaymentMethodByRoomId = (response?.Data || [])
  .filter(x => {
    return (x?.KeyCode === 'PAYMENT_METHOD_TO_GOLF_CODE' || x?.KeyCode === 'PAYMENT_METHOD_BY_BANK_ROOM') && !isNaN(x?.KeyValue);
  })
  .map(x => Number(x.KeyValue));
        }
    })

      await booking.getConfigInfo({ KeyGroup: 'BOOKING_CONFIG' }).then(async response => {
        if (response.Status === '200') {
          this.zoneId = response?.Data.filter(item => item.KeyCode === 'BAR_LOCATION_4_ACCOUNTANT')
          return this.getListPaymentType_RPF02()
        }
      })
    },
    async getListPaymentType_RPF02() {

      await booking.api_RPF02({
        ZoneId: this.zoneId.map(item => String(item.KeyValue)),
      }).then(async response => {
        if (response.Status === '200') {
          this.listPaymentType = response?.Data?.PaymentType
          this.paymentTypeOptions = response?.Data?.PaymentType.map(x => ({
            title: x.Name,
            value: x.Code,
          }))
        }
      })

       booking.api_RPF02({
        ZoneId: JSON.parse(localStorage.getItem('userGolfData')).BarLocation.map(item => String(item.Id)),
      }).then(async response => {
        if (response.Status === '200') {
          this.optionPaymentMethod = response?.Data?.PaymentType
          .flatMap(item => item.PaymentMethod) // gom tất cả PaymentMethod lại thành 1 mảng
          .map(pm => ({ id: pm.Id, label: pm.Name })); // lấy Id và Name

         this.optionPaymentMethod =  this.optionPaymentMethod.filter(
  (pm, index, self) =>
    index === self.findIndex(p => p.id === pm.id)
);
 if(!this.isShowPaymentByRoom){
 this.optionPaymentMethod = this.optionPaymentMethod.filter(item => !this.listPaymentMethodByRoomId.includes(item.id));

 }
        }
      })
    },
    async getListCashier_RCS01() {
      await booking.api_RCS01().then(response => {
        if (response.Status === '200') {
          this.listCashiers = response?.Data?.Cashier.map(x => ({
            id: x.Id,
            label: x.CashierName,
          }))
        }
      })
    },
    async getListClient() {
      await commonServices
        .getCompany()
        .then(res => {
          if (res.Status === '200') {
            this.listClient = res.Data.Client
          }
        })
    },
    async getListPaymentMethodEInvoice() {
      await invoice
        .api_RPMI04()
        .then(res => {
          if (res.Status === '200') {
            this.listPaymentMethodEInvocie = res.Data.map(x => ({
              title: x.Name,
              value: x.Code,
            }))
          }
        })
    },
    async getListPayment_RPMI01() {
      this.isLoading = true
      this.search.Page= this.currentPage,
      this.search.PageSize= this.perPage,
      await invoice.api_RPMI01(this.search)
        .then(res => {
          if (res) {
            this.listPayment = res.Data.Payment
            this.totalRow = res?.Data?.TotalRecordings
            this.TotalAmountOfEInvoice = res?.Data?.TotalAmountOfEInvoice
            this.TotalAmountNotOfEInvoice = res?.Data?.TotalAmountNotOfEInvoice
            this.TotalAmount = res?.Data?.TotalAmount
          }
        })
      this.isLoading = false
    },

    openSidebarMergeService() {
      this.getSelectedData()
      if (this.selectedRowsData.length) {
        this.paymentDataSelected = this.selectedRowsData.map(x => ({
          Id: x.Id,
          BookingType: x.BookingType,
        }))
        this.$root.$emit('bv::toggle::collapse', 'sidebar-merge-service')
      } else {
        this.showToast('error', this.$t('golf_common_please_select_payment'))
      }
    },
    handelEvent(event) {
      if (event.type == 'after_issue_invoice') {
        this.getListPayment_RPMI01()
      }
      if (event.type == 'after_delete_invoice') {
        this.getListPayment_RPMI01()
      }
      if (event.type == 'refresh_list_payment') {
        this.getListPayment_RPMI01()
      }
    },
    exportExcel() {
      this.generateXLSXListPayment()
      // const workbook = new Workbook()
      // const worksheet = workbook.addWorksheet('Payment')
      // exportDataGrid({
      //   component: this.dataGrid,
      //   worksheet,
      //   autoFilterEnabled: true,
      //   PrintSelectedRowsOnly: true,
      //   topLeftCell: { row: 4, column: 1 },
      //   customizeCell: function(options) {
      //     const { gridCell, excelCell } = options;
      //     if(gridCell.rowType === 'data') {
      //       if(gridCell.column.dataField == 'TeeTime') {
      //         if(gridCell.value.TeeName) {
      //           excelCell.value = convertUTC(gridCell.value.OpenDateTime,'HH:mm') + ' ' + gridCell.value.TeeName 
      //         } else {
      //           excelCell.value = convertUTC(gridCell.value.OpenDateTime,'HH:mm')
      //         }
      //       }
      //       if(gridCell.column.dataField == 'FiscalPaymentDate') {
      //         excelCell.value =  convertUTC(gridCell.value,'DD/MM/YYYY HH:mm')
      //       }
      //       if(gridCell.column.dataField == 'Invoice') {
      //         if(gridCell.value.length > 0) {
      //           excelCell.value = JSON.stringify(gridCell.value.map(x => x.InvoiceNo))
      //         } else {
      //           excelCell.value = ''
      //         }
              
      //       }
      // } }
      // }).then(cellRange => {
      //   // header
      //   const headerRow = worksheet.getRow(2)
      //   headerRow.height = 30
      //   worksheet.mergeCells(2, 1, 2, 8)

      //   headerRow.getCell(1).value = `DANH SÁCH THANH TOÁN (từ ${this.convertUTC(this.search.FromDate, 'DD/MM/YYYY')} đến ${this.convertUTC(this.search.ToDate, 'DD/MM/YYYY')})`
      //   headerRow.getCell(1).font = { name: 'Segoe UI Light', size: 22 }
      //   headerRow.getCell(1).alignment = { horizontal: 'center' }

      //   // footer
      //   const footerRowIndex = cellRange.to.row + 2
      //   const footerRow = worksheet.getRow(footerRowIndex)
      //   worksheet.mergeCells(footerRowIndex, 1, footerRowIndex, 8)
      //   footerRow.getCell(1).font = { color: { argb: 'BFBFBF' }, italic: true }
      //   footerRow.getCell(1).alignment = { horizontal: 'right' }
      // }).then(() => {
      //   workbook.xlsx.writeBuffer().then(buffer => {
      //     saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Payment.xlsx')
      //   })
      // }) 
    },
      async generateXLSXListPayment() {
      const bodyreq = {
        ClientId: this.search.ClientId,
        KeyWord: this.search.KeyWord,
        BDC: this.search.BDC,
        FromDate: this.search.FromDate,
        ToDate: this.search.ToDate,
        PaymentCode: this.search.PaymentCode,
        InvoiceNo: this.search.InvoiceNo,
        Type: this.search.Type,
        isGetTotal: true,
        Page: this.currentPage,
        PageSize: this.perPage,
      };
      try {
        const res = await invoice.api_RPMI01(bodyreq);
    
        if (
          !res ||
          !res.Data ||
          !Array.isArray(res.Data.Payment) ||
          res.Data.Payment.length === 0
        ) {
          console.warn("Không có dữ liệu hóa đơn để export.");
          return;
        }
    
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Payment");
    
        // Cấu hình cột
        // const columns = [
        //   { key: "SerialNo", caption: "SerialNo", width: 10 },
        //   { key: "InvoiceNo", caption: "InvoiceNo", width: 15 },
        //   { key: "InvoiceOldNo", caption: this.$t('golf_tax_invoice_invoice_old_no'), width: 20 },
        //   { key: "MemberName", caption: this.$t('golf_common_full_name'), width: 20 },
        //   { key: "InvoiceDate", caption: "InvoiceDate", width: 20 },
        //   { key: "CompanyName", caption: this.$t('golf_tax_invoice_company_name'), width: 25 },
        //   { key: "Email", caption: this.$t('golf_tax_invoice_company_email'), width: 25 },
        //   { key: "CompanyAddress", caption: this.$t('golf_tax_invoice_company_address'), width: 30 },
        //   { key: "TaxCode", caption: this.$t('golf_tax_invoice_tax_code'), width: 20 },
        //   { key: "TransactionCodeName", caption: this.$t('golf_tax_invoice_payment_method'), width: 20 },
        //   { key: "TotalAmount", caption: this.$t('golf_common_total'), width: 20, style: { numFmt: "#,##0" } },
        //   { key: "CreateName", caption: this.$t('golf_payment_cashier'), width: 20 },
        //   { key: "EinvoiceStatus", caption: this.$t('golf_common_status'), width: 20 },
        // ];
        const columns = this.configTable.map(item =>({
          key: item.field,
          caption: item.caption,
          width : 30,
        })) 
        worksheet.columns = columns;
        const formatCols = ['TotalAmount', 'AmountOfEInvoice','AmountNotEInvoice'];

        worksheet.eachRow((row, rowNumber) => {
        row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        const key = worksheet.columns[colNumber - 1]?.key;
        if (formatCols.includes(key)) {
          cell.numFmt = "#,##0";
          cell.alignment = {
          horizontal: "right",
          vertical: "middle",
          wrapText: false,
          shrinkToFit: true
      };
        }
        });
        });
        // Tiêu đề dòng 2
        worksheet.getRow(2).values = columns.map(col => col.caption);
    
        // Cố định dòng tiêu đề
        worksheet.views = [{ state: "frozen", xSplit: 0, ySplit: 2 }];
    
        // Dữ liệu
        res.Data.Payment.forEach((item) => {
          worksheet.addRow({
            BDC: item.BDC,
            FullName: item.FullName || " ",
            NumberOfHole: item.NumberOfHole,
            TeeTime: item.TeeTime ?  convertUTC(item.TeeTime.OpenDateTime,'HH:mm')+" "+  (item.TeeTime.TeeName || " ") : " ",
            ClientName: item.ClientName,
            PaymentCode: item.PaymentCode ,
            Id :  item.BookingType == 'FOLIO_NON_GOLF' || item.BookingType == 'FOLIO' ? item.Id : " ",
            FiscalPaymentDate: this.convertUTC(item.FiscalPaymentDate),
            TotalAmount: item.TotalAmount,
            AmountOfEInvoice: item.AmountOfEInvoice,
            AmountNotEInvoice: item.AmountNotEInvoice,
            Invoice: item.Invoice ? item.Invoice.map(item => item.InvoiceNo).join(", ") : " ",
           
          });
        });
    
        // Căn giữa + in đậm dòng tiêu đề
        worksheet.getRow(2).eachCell((cell) => {
          cell.font = { bold: true };
          cell.alignment = { 
            horizontal: "center",
            vertical: "middle" ,
    
            };
        });
    
        // Căn giữa toàn bộ dữ liệu
        worksheet.eachRow((row) => {
          row.eachCell((cell) => {
            cell.alignment = { 
              horizontal: "left", 
              vertical: "middle", 
              rapText: false 
            };
          });
        });
    
        // Tiêu đề chính dòng 1 (merge từ A1 đến cột cuối)
        const lastColLetter = worksheet.getColumn(columns.length)._letter || "M";
        worksheet.mergeCells(`A1:${lastColLetter}1`);
        const titleCell = worksheet.getCell("A1");
        titleCell.value = `DANH SÁCH THANH TOÁN (từ ${this.convertUTC(this.search.FromDate, 'DD/MM/YYYY')} đến ${this.convertUTC(this.search.ToDate, 'DD/MM/YYYY')})`;
        titleCell.font = { bold: true, name: 'Segoe UI Light', size: 22  };
        titleCell.alignment = { horizontal: "center", vertical: "middle" };
    
        // Xuất file
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer], { type: "application/octet-stream" }), "Payment.xlsx");
      } catch (error) {
        console.error("Lỗi khi xuất Excel:", error);
      }
    },
    async openPrintInvoice(data) {
      if(!this.checkModuleEInvocie) { return }
      if (data.column.name != 'action' &&  data.column.type != 'selection' && data.data.BookingType != 'FOLIO_NON_GOLF' && data.data.BookingType != 'FOLIO' && data.data.BookingType != 'FOLIO_HOTEL' && data.column.dataField == 'PaymentCode') {
        if(data.data.Id) {
          const routeData = this.$router.resolve({ name: 'booking-print-invoice', params: { id: data.data.Id } })
          window.open(routeData.href, '_blank')
        }
      }
    },
    openModalViewEInvoice(data) {
      
      this.$refs.sidebarMergeService.viewEInvocie_RIVAT03(data.Id, 'DownloadPDF')
      this.isLoading = true
      setTimeout(() => {
        this.isLoading = false;
    }, 1500); 
    }
  },
}
